import type { ConfigurationValidationError } from '@festina/configuration-general-types/configuration'
import type { LocationErrors } from '@festina-life/api'

import { isChangesetValidationError } from '../types'
import type { ValidationErrorWithLocation } from './types'

export const collectAndCategoriseErrors = ({
  workspaceErrors,
  branchErrors,
}: {
  workspaceErrors: LocationErrors[]
  branchErrors: LocationErrors[]
}) =>
  [...workspaceErrors, ...branchErrors]
    .reduce<ValidationErrorWithLocation<ConfigurationValidationError>[]>(
      (acc, layerErrors) => {
        const { errors: errorList, layer, block } = layerErrors
        acc.push(
          ...((errorList ?? []).map((error) => ({
            error,
            location: workspaceErrors.includes(layerErrors)
              ? 'workspace'
              : 'baseBranch',
            layer,
            block,
          })) satisfies ValidationErrorWithLocation<ConfigurationValidationError>[]),
        )
        return acc
      },
      [],
    )
    .sort((validationA, validationB) => {
      if (
        (isChangesetValidationError(validationA.error) &&
          !isChangesetValidationError(validationB.error)) ||
        (validationA.layer.tenantId && !validationB.layer.tenantId) ||
        (validationA.location === 'workspace' &&
          validationB.location === 'baseBranch')
      ) {
        return -1
      }

      if (
        (!isChangesetValidationError(validationA.error) &&
          isChangesetValidationError(validationB.error)) ||
        (!validationA.layer.tenantId && validationB.layer.tenantId) ||
        (validationA.location === 'baseBranch' &&
          validationB.location === 'workspace')
      ) {
        return 1
      }

      return 0
    })
